import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const ReactAppDirective = angular.module('link-maestro').directive('reactAppDirective', [
  'CommonService',
  'ConnectionService',
  'profileService',
  'AppGlobService',
  'appGlobApi',
  'PlanConnectionService',
  'messageService',
  'STRING_REF',
  'tesseractReportService',
  '$compile',
  '$rootScope',
  function (
    CommonService,
    ConnectionService,
    profileService,
    AppGlobService,
    appGlobApi,
    PlanConnectionService,
    messageService,
    STRING_REF,
    tesseractReportService,
    $compile,
    $rootScope
  ) {
    return {
      template: '<div id="reactapp" class="react-part"></div>',
      replace: true,
      scope: {
        page: '@', //vk
        pageParams: '<',
      },
      link: function (scope, el, attrs) {
        scope.userName = CommonService.auth.getCurrentUser().username;
        const pageParams = scope.pageParams;
        const reactapp = document.getElementById('reactapp');
        const reactHeaderScope = $rootScope.$new();
        scope.$watchGroup(
          ['page', 'pageParams'],
          function (newValue, oldValue) {
            if (angular.isDefined(newValue)) {
              ReactDOM.render(
                <App
                  services={{
                    ConnectionService,
                    CommonService,
                    profileService,
                    appGlobApi,
                    AppGlobService,
                    PlanConnectionService,
                    messageService,
                    STRING_REF,
                    tesseractReportService,
                    $compile,
                    $scope: reactHeaderScope,
                  }}
                  page={scope.page} //vk
                  pageParams={pageParams}
                />,
                reactapp
              );
            }
          },
          true
        );

        scope.$on('$destroy', function () {
          ReactDOM.unmountComponentAtNode(reactapp);
          reactHeaderScope.$destroy();
        });
      },
    };
  },
]);

export default ReactAppDirective;